let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1cF53")).then(() => parcelRequire('97ktx'));